import { createEffect } from 'solid-js'
import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
import type { Engine } from '../../core/engine/Engine.type'
import createOnFrameUpdateIsActiveSignal from '../../event/GameObject3D/GameObject3DFrameUpdate/createOnFrameUpdateIsActiveSignal'
import createCrtShader from './createCrtShader'

export default function createMountedCrtShader(
  engine: Engine,
  composer: EffectComposer,
) {
  const crtShaderEffect = new ShaderPass(createCrtShader())
  composer.addPass(crtShaderEffect)

  const { uniforms } = crtShaderEffect

  uniforms.curvatureStrength.value = 1.0
  uniforms.vignetteStrength.value = 0.85
  uniforms.scanlineStrength.value = 0.55
  uniforms.grilleStrength.value = 0.35
  uniforms.saturation.value = 0.95

  const u_time = uniforms.time
  const [getIsActive, setIsActive] = createOnFrameUpdateIsActiveSignal(engine, (dt: number, at: number) => {
    u_time.value = at / 1000
  })

  // setIsActive(true)
  setIsActive(false)
  // crtShaderEffect.enabled = false
  createEffect(() => {
    crtShaderEffect.enabled = getIsActive()
  })

  return crtShaderEffect
}
